<template>
  <div class="view-container text-center">
    <div class="text-right cursor-pointer">
      <b-button variant="link" @click="back">
        <font-awesome-icon icon="times" />
      </b-button>
    </div>

    <h1>Comunicazioni da Roma Capitale</h1>

    <loading-spinner v-if="loading" />
    <div v-else-if="$store.getters.isAuthenticated" class="row justify-content-between mx-2 mt-5 mb-2 align-middle">
      <h4>Elenco comunicazioni</h4>
    </div>

    <b-alert v-if="!loading && !items.length" show variant="info" class="my-4">
      Non ci sono comunicazioni da visualizzare.
    </b-alert>

    <b-table v-else-if="items.length" :per-page="perPage" :current-page="currentPage" striped bordered hover small
      :fields="fields" :items="sortedItems" :responsive="true" :busy="false" @sort-changed="onSortChanged"
      :sort-compare="sortData">
      <template v-slot:head(icon)>
        <font-awesome-icon icon="file-alt" size="lg" class="text-muted" />
      </template>

      <template v-slot:head(button)>
        <font-awesome-icon icon="download" size="lg" class="text-muted" />
      </template>

      <template v-slot:cell(button)="data">
        <a v-if="data.item.DOWNLOAD !== null" :href="urlComunicazione(data.item.IDCOMUNICAZIONE, data.item.PROVENIENZA)"
          target="_blank" @click.stop v-b-tooltip.hover title="Scarica il documento">
          <font-awesome-icon v-if="data.item.button !== ''" icon="file-alt" size="lg"
            class="text-success cursor-pointer" />
        </a>
      </template>
    </b-table>
    <div class="row justify-content-between mx-0 mt-0 mb-2 align-middle">
      <div class="text-right">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
      </div>
      <div class="text-right">
        <b-form-group description="Per pagina" class="mb-0">
          <b-form-select :options="pageOptions" v-model="perPage" />
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import LoadingSpinner from '@/components/LoadingSpinner'

export default {
  components: {
    LoadingSpinner
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'TIPO_COMUNICAZIONE', label: 'Comunicazione', sortable: true },
        { key: 'RAPPORTO_UTENZA', label: 'Rapporto Utenza', sortable: true },
        { key: 'BU', label: 'BU', sortable: true },
        { key: 'INDIRIZZO', label: 'Indirizzo', sortable: true },
        { key: 'CIVICO', label: 'Civico', sortable: true },
        { key: 'DATA_EMISSIONE', label: 'Data Emissione', sortable: true },
        { key: 'COMPETENZA_DECORRENZA', label: 'Competenza/Decorrenza', sortable: true },
        { key: 'DATA_PROTOCOLLO', label: 'Data Protocollo', sortable: true },
        { key: 'PROTOCOLLO', label: 'Protocollo', sortable: true },
        { key: 'button', label: 'Download' }
      ],
      loading: true,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20],
      sortBy: '',
      sortDesc: false
    }
  },

  async created() {
    await this.load()
  },

  methods: {
    back() {
      this.$router.push({ name: 'home' })
    },

    async load() {
      try {
        this.loading = true
        await this.$store.dispatch('comunicazioni/loadItems')
        this.items = this.$store.state.comunicazioni.items
        this.totalRows = this.items.length || 0
      } catch (err) {
        this.$ui.showError(err)
      }
      this.loading = false
    },

    urlComunicazione(id, provenienza) {
      return `/api/comunicazioni/${id}/download/${provenienza}`
    },

    parseDate(dateString) {
    if (!dateString) return null;
    const parts = dateString.split('/');
    let day, month, year;

    if (parts.length === 3) {
      [day, month, year] = parts;
    } else if (parts.length === 2) {
      [month, year] = parts;
      day = '1';
    } else {
      return null;
    }

    return new Date(year, month - 1, day);
  },

    onSortChanged({ sortBy, sortDesc }) {
      this.sortBy = sortBy
      this.sortDesc = sortDesc
    },

    sortData(a, b, key) {
      if (key === 'DATA_EMISSIONE' || key === 'COMPETENZA_DECORRENZA' || key === 'DATA_PROTOCOLLO') {
        const dateA = this.parseDate(a[key])
        const dateB = this.parseDate(b[key])
        if (dateA < dateB) return -1
        if (dateA > dateB) return 1
        return 0
      } else {
        if (a[key] < b[key]) return -1
        if (a[key] > b[key]) return 1
        return 0
      }
    }
  },

  computed: {
    sortedItems() {
      const itemsCopy = [...this.items]

      itemsCopy.sort((a, b) => this.sortData(a, b, this.sortBy))

      if (this.sortDesc) {
        itemsCopy.reverse()
      }
      return itemsCopy
    }
  }


}
</script>
